export default {
    stack: {
      title: 'Stack',
      tech: [
        {
          img: process.env.PUBLIC_URL + '/images/CPP.png',
          alt: 'C++',
        },
        {
          img: process.env.PUBLIC_URL + '/images/Python.png',
          alt: 'Python',
        },
        {
          img: process.env.PUBLIC_URL + '/images/HTML.png',
          alt: 'HTML',
        },
        {
          img: process.env.PUBLIC_URL + '/images/CSS.png',
          alt: 'CSS',
        },
        {
          img: process.env.PUBLIC_URL + '/images/JS.png',
          alt: 'JavaScript',
        },
        {
          img: process.env.PUBLIC_URL + '/images/MongoDB.svg',
          alt: 'mongodb',
        },
        {
          img: process.env.PUBLIC_URL + '/images/Express.svg',
          alt: 'express',
        },
        {
          img: process.env.PUBLIC_URL + '/images/logo512.png',
          alt: 'react',
        },
        {
          img: process.env.PUBLIC_URL + '/images/NodeJS.png',
          alt: 'node',
        },
      ],
      // desc: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only`,
    },
  };